
import { useDispatch, useSelector } from "react-redux";
import {
    setFindingsReportAnalysisData,
    setFindingsReportAnalysisId,
    setIsFindingsReportFullWidth,
    setIsFindingsReportIsOpen,
    setRefreshAnalysisList,
    setNotificationData,
    setHasAccessToReport,
    setRefreshModal1Open, setRefreshModal2Open, setRefreshModal1Action, setRefreshModal2Action,
    resetRefreshReport,
    setOldAnalysisId,
    setNewAnalysisId,
    setDisableReportIndex,
    addDisableReportId,
    removeDisableReportId,
    setRefreshAnalysisPage,
    setFindingReportData,
    setFindingReportContentLength,
    setExploreFilterApplyData,
    setMaxReportCards,
    setCheckCardLimitRunning,
    setUniqueQuestionIdCount
} from "../../reducer/PEBCommonSlice";
import { NotificationTypes } from "../Notification/Notification";
import { checkCardLimit, copyAnalysis, getAnalysisData, isReportNameUnique, refreshExistingReport } from "../../services/ExperienceBankAPI";
import { checkAsyncStatus } from "../../services/ResponsesAPI";
import { displayExploreFilterDataAPI, saveExploreFilterAPI } from "../../services/ExploreAPI";
import { MAX_ALLOWED_CARDS } from "../../constants/ResponseDetailConstant";

export const useRefreshActions = () => {
    const dispatch = useDispatch();

    const refreshModal1Open = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal1Open);
    const refreshModal2Open = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal2Open);
    const refreshModal1Action = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal1Action);
    const refreshModal2Action = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal2Action);
    const supportingData = useSelector(
        (state) => state.PEBCommon?.supportingData
    );
    const userInfo = useSelector((state) => state.PEBCommon?.userDetail); // get User details

    const uniqueQuestionIdCount = useSelector((state) => state.PEBCommon?.refreshReport?.uniqueQuestionIdCount);
    const oldAnalysisId = useSelector((state) => state.PEBCommon?.refreshReport?.oldAnalysisId);
    const newAnalysisId = useSelector((state) => state.PEBCommon?.refreshReport?.newAnalysisId);
    const filterData = useSelector((state) => state.PEBCommon?.filterData);
    const recordData = useSelector((state) => state.PEBCommon?.recordData);
    const disableReportIndex = useSelector((state) => state.PEBCommon?.refreshReport.disableReportIndex);
    const targetPopulationFilterData = useSelector((state) => state.PEBCommon?.refreshReport.targetPopulationFilterData);
    const allCardsData = useSelector(
        (state) => state.PEBCommon?.findingsReport?.supporting_data
    );
    const maxReportCards = useSelector((state) => state.PEBCommon?.refreshReport?.maxReportCards);


    function getUniqueQuesIdCount(supporting_data) {
        const uniqueIds = new Set();
        // console.log("", supporting_data);


        supporting_data.forEach(item => {
            if (item.ques_id) {
                uniqueIds.add(item.ques_id);
            }
        });

        return uniqueIds.size;
    }


    const openFirstModal = async(index, analysis_id, analysisData) => {

        dispatch(setDisableReportIndex(index));
        // dispatch(addDisableReportId(rowIndex));
        dispatch(setOldAnalysisId(analysis_id));


        const payload = {
            analysis_id: analysisData?.analysis_id,
            analysis_refresh_date: analysisData?.analysis_refresh_date,
            screen_name: "findings",
            user_id: userInfo?.user_id,
            allowed_geographies: userInfo?.allowed_geographies || [],
            allowed_indications:userInfo?.allowed_indications || [],
        };
        // console.log("payload", payload);

        await getFindingsReportData(payload);
        getUniqueQuesIdCount(allCardsData);
        
        
        dispatch(setRefreshModal1Open(true));
    };

    const getFindingsReportData = async (payload) => {
        let { data, headers } = await getAnalysisData(payload);
        const response = data;
        let sequence = 1;
        const sortedInsightList = response.result.insight_mapped_data.sort(
            (a, b) => {
                const aValue = a.insight_sequence;
                const bValue = b.insight_sequence;
                return aValue - bValue;
            }
        );
        sortedInsightList.forEach((element) => {
            element.questions_list.forEach((question) => {
                question.sequence = sequence;
                sequence++;
            });
        });
        response.result.unmapped_data.forEach((element) => {
            element.sequence = sequence++;
        });

        dispatch(
            setFindingReportData({
                insight_list: sortedInsightList,
                supporting_data: response.result.unmapped_data,
            })
        );
        const uniqueQuesIds = getUniqueQuesIdCount(response.result.unmapped_data);
        // console.log(" ids", uniqueQuesIds);
        dispatch(setUniqueQuestionIdCount(uniqueQuesIds));
        // console.log("hulk", uniqueQuesIds);
        const numberOfCriteria = response.result.filters_data.length;
        // console.log(" criteria = ", numberOfCriteria);

        dispatch(setMaxReportCards(uniqueQuesIds * numberOfCriteria));

        dispatch(
            setFindingReportContentLength(
                headers && headers["content-length"]
            )
        )
        localStorage.setItem(
            "suppCardOrder",
            response.result.analysis_total_ques_count
        );
    };

    const handleFirstModalClick = async (action, analysisData) => {
        // console.log(
        //     "action", action
        // );
        // console.log("payload ", analysisData);

        const payload = {
            analysis_id: analysisData?.analysis_id,
            analysis_refresh_date: analysisData?.analysis_refresh_date,
            screen_name: "findings",
            user_id: userInfo?.user_id,
            allowed_geographies: userInfo?.allowed_geographies || [],
            allowed_indications:userInfo?.allowed_indications || [],
        };
        // console.log("payload", payload);

        // getFindingsReportData(payload);  
        if (action == "refreshUpdateCriteria") {
            // open diff pop-up
            // console.log("analysisData", analysisData);


            // console.log("payload", payload);
            //   getFindingsReportData(payload);  
            const response = await displayExploreFilterDataAPI(payload)
            dispatch(setExploreFilterApplyData(response?.result?.filters_data));

            dispatch(setRefreshModal1Action(action)); // Save the action
            dispatch(setRefreshModal1Open(false));
            //   call display-analyisapi/explore-api with nalysis data
            //   setIsCreateExportModalOpen(true);
            return;
        }
        else {
            dispatch(setRefreshModal1Action(action)); // Save the action
            dispatch(setRefreshModal1Open(false));
            dispatch(setRefreshModal2Open(true));
        }

    };

    const handleTargetPopulationFilterData = async (action,analysis_id) => {
        if (action == "refreshExistingExport") {

            let payload = {
                user_id: userInfo?.user_id,
                screen_name: "data_coverage",
                comparator_flag: true,
                delete_comparator_names: [],
                filters_data: targetPopulationFilterData,
                display_chart_nm: [],
                analysis_id: analysis_id || "",
            };
            let response = await saveExploreFilterAPI(payload);
        }
    }

    // 
    const isMaxAllowedCardsLimitReached = async(updatedFiltersData=null) => {
        // console.log("hulk",updatedFiltersData , uniqueQuestionIdCount);
        
        dispatch(
            setNotificationData({
                type: NotificationTypes.INFO,
                  duration:0,
                  loading:true,
                message: (
                    <>
                        {/* <strong>MAX Threshold reached , CALL API TO CONFIRM</strong> */}
                        <p>Validating your criteria or target population selection to ensure the cards to be added to report does not exceed the threshold for maximum allowed number of cards in a report</p>
                        {/* <br/>
                      Try searching with different keywords. */}
                    </>
                ),
            })
        );
        const payload = {
            user_id: userInfo.user_id,
            analysis_id: oldAnalysisId || "",
            screen_name: "analysis_library",
            analysis_refresh_type: "refresh_current",
            allowed_geographies: userInfo?.allowed_geographies || [],
            allowed_indications:userInfo?.allowed_indications || [],
            // comparator_data: updatedFiltersData
            ...(updatedFiltersData && { comparator_data: updatedFiltersData })
        };

        // it has to be >=
        // uniqueQuesIds * updatedFiltersData.length
        let maxReportCardsCalculated = 0;
        if(updatedFiltersData){
            // coming from target pop
            maxReportCardsCalculated = uniqueQuestionIdCount * updatedFiltersData.length;
        }
        else{
            maxReportCardsCalculated = maxReportCards;
        }
        // alert(uniqueQuesIds,"..." , updatedFiltersData.length)
        if (maxReportCardsCalculated >= MAX_ALLOWED_CARDS) {
            dispatch(setCheckCardLimitRunning(true));
            let response = await checkCardLimit(payload);
            let totalCards = response?.result?.total_number_of_cards;
            dispatch(setCheckCardLimitRunning(false));
            if(totalCards>MAX_ALLOWED_CARDS){
                dispatch(
                    setNotificationData({
                        type: NotificationTypes.ERROR,
                          duration:10,
                        //   loading:true,
                        message: (
                            <>
                                {/* <strong>MAX Threshold reached , CALL API TO CONFIRM</strong> */}
                            <p> The selected criteria or target population exceeds the maximum allowed limit for cards in the report. Please refine your selection to generate a more targeted and manageable report.
                            </p>
                                {/* <br/>
                              Try searching with different keywords. */}
                            </>
                        ),
                    })
                );
                return true;
            }
            else{
                // proceed
                // handleFirstModalClick('refreshData',filterExportLibraryCurrentPageData[disableReportIndex]);
                // dispatch(setTargetPopulationFilterData(filters_data));
                dispatch(
                    setNotificationData({
                        type: NotificationTypes.SUCCESS,
                        //   duration:2,
                        //   loading:true,
                        message: (
                            <>
                                <strong>Check Successful</strong>
                                {/* <p>Validating your criteria or target population selection to ensue the cards to be added to report does not exceed the threshold for maximum allowed number of cards in a report</p> */}
                                {/* <br/>
                              Try searching with different keywords. */}
                            </>
                        ),
                    })
                );
            }
           
            // dispatch(setRefreshModal2Open(false));
            // dispatch(removeDisableReportId(analysis_id));
            // dispatch(setDisableReportIndex(-1));
            return false;
        }
        dispatch(
            setNotificationData({
                type: NotificationTypes.SUCCESS,
                  duration:2,
                //   loading:true,
                message: (
                    <>
                        <strong>Check Successful</strong>
                        {/* <p>Validating your criteria or target population selection to ensue the cards to be added to report does not exceed the threshold for maximum allowed number of cards in a report</p> */}
                        {/* <br/>
                      Try searching with different keywords. */}
                    </>
                ),
            })
        );
        return false;
    }

    const handleSecondModalClick = (action, newReportName = "", analysisData = [], newCreatedAnalysisID) => {
        let { analysis_id, analysis_name } = analysisData;
        // targetPopulationFilterData
        let refreshNewlyCreatedReport = false;
        if (analysisData.length == 0) {
            refreshNewlyCreatedReport = true;
        }
        if (refreshNewlyCreatedReport) {
            analysis_id = newCreatedAnalysisID;
        }
        dispatch(setRefreshModal2Action(action));
        // dispatch(setRefreshModal2Open(false));
        if (action == "refreshExistingExport") {

            // if (maxReportCards >= MAX_ALLOWED_CARDS) {
            //     dispatch(
            //         setNotificationData({
            //             type: NotificationTypes.ERROR,
            //             //   duration:0,
            //             //   loading:true,
            //             message: (
            //                 <>
            //                 <p> The selected criteria or target population exceeds the maximum allowed limit for cards in the report. Please refine your selection to generate a more targeted and manageable report.
            //                 </p>
            //                     {/* <br/>
            //               Try searching with different keywords. */}
            //                 </>
            //             ),
            //         })
            //     );
            //     dispatch(setRefreshModal2Open(false));
            //     dispatch(removeDisableReportId(analysis_id));
            //     dispatch(setDisableReportIndex(-1));
            //     return;
            // }
            if (targetPopulationFilterData.length > 0) {
                handleTargetPopulationFilterData(action,analysis_id);
            }


            dispatch(setRefreshModal2Open(false));


            refreshExistingReportFn(analysis_id, refreshNewlyCreatedReport);
        }
        else if (action == "refreshSubmitNewName") {
            // getUniqueNameFn(newReportName,analysis_id,analysis_name);

        }
        else {
            // fetch exploreFilterApplyData redux state and pass it in payload 
            // refreshCreateNewExport
            //   refreshCreateNewExportFn();
        }
        // dispatch(setDisableReportIndex(-1));
    };

    const copyNewNameAnalysisFn = async (newReportName, analysis_id, analysis_name) => {
        let payload = {
            analysis_id: oldAnalysisId,
            new_analysis_name: newReportName,
            screen_name: 'analysis',
            user_id: userInfo.user_id,
            analysis_name: analysis_name
        }
        let response = await copyAnalysis(payload)
        dispatch(
            setNotificationData({
                type: NotificationTypes.SUCCESS,
                //   duration:0,
                //   loading:true,
                message: (
                    <>
                        <strong>Refresh Export Process Completed </strong>

                        {/* <br/>
                  Try searching with different keywords. */}
                    </>
                ),
            })
        );
        dispatch(removeDisableReportId(analysis_id));
        dispatch(setRefreshAnalysisPage(true));
        dispatch(setRefreshModal2Open(false));
    }

    const getUniqueNameFn = async (newReportName, analysis_id, analysis_name) => {
        let payload = {
            user_id: userInfo.user_id,
            screen_name: "report modal",
            analysis_name: newReportName,
        };
        dispatch(addDisableReportId(analysis_id));

        const response = await isReportNameUnique(payload);
        if (response.result) {
            // go ahead

            // call copy api 
            // new key below
            // new_analysis_name

            // const 
            dispatch(
                setNotificationData({
                    type: NotificationTypes.INFO,
                    duration: 0,
                    loading: true,
                    message: (
                        <>
                            <strong>Refresh Export Process in Progress  </strong>
                            {/* <br/>
                      Try searching with different keywords. */}
                        </>
                    ),
                })
            );
            copyNewNameAnalysisFn(newReportName, analysis_id, analysis_name);
            // copyAnalysis



        }
        else {
            // give error msg
            dispatch(
                setNotificationData({
                    type: NotificationTypes.ERROR,
                    //   duration:0,
                    //   loading:true,
                    message: (
                        <>
                            <strong>{response.message}  </strong>
                            {/* <br/>
                      Try searching with different keywords. */}
                        </>
                    ),
                })
            );
            dispatch(removeDisableReportId(analysis_id));

        }
    }

    const refreshExistingReportFn = async (analysis_id, refreshNewlyCreatedReport) => {
        // alert('refreshExistingReportFn')
        // setLoading(true);
        // dispatch(setDisableReportIndex(-1));
        dispatch(
            setNotificationData({
                type: NotificationTypes.INFO,
                duration: 0,
                loading: true,
                message: (
                    <>
                        <strong>Refresh Export Process in Progress  </strong>
                        {/* <br/>
                  Try searching with different keywords. */}
                    </>
                ),
            })
        );
        const payload = {
            user_id: userInfo.user_id,
            analysis_id: oldAnalysisId,
            screen_name: "analysis_library",
            analysis_refresh_type: "refresh_current",
            allowed_geographies: userInfo?.allowed_geographies || [],
            allowed_indications:userInfo?.allowed_indications || [],
            ...(refreshNewlyCreatedReport && { new_analysis_id: analysis_id })
        };
        // if(refreshNewlyCreatedReport){
        //     payload.new_analysis_id = analysis_id
        // }

        //         {
        //     "user_id": "shivansh.bhasin@zs.com",
        //     "screen_name": "analysis_library",
        //     "analysis_id": "6d718e2f-8514-4486-9e98-4358ee15f5fd",
        //     "new_analysis_id":"",
        //     "analysis_refresh_type":"refresh_current"
        // }


        // setTimeout(() => {
        //   // nothing now
        //   dispatch(setDisableReportIndex(-1));
        //   dispatch(
        //     setNotificationData({
        //       type: NotificationTypes.SUCCESS,
        //       message: (
        //         <>
        //           <strong>Refresh Export Process Completed </strong> 

        //           {/* <br/>
        //           Try searching with different keywords. */}
        //         </>
        //       ),
        //     })
        //   );
        //   // setLoading(false);
        // }, 2000);
        dispatch(addDisableReportId(analysis_id));

        const response = await refreshExistingReport(payload);
        let backgroundTaskId = response?.bground_task_id || "";

        const payload2 = {
            user_id: userInfo.user_id,
            bground_task_id: backgroundTaskId
        }
        // console.log("result setting empty");

        // setAddAllApiData({});
        checkStatusUntilSuccess(payload2, analysis_id);
        // console.log("respon");

        // setLoading(false);
        // dispatch(setRefreshAnalysisList(response));
        // dispatch(
        //   setNotificationData({
        //     type: NotificationTypes.SUCCESS,
        //     message: response?.message,
        //   })
        // );
    };

    const checkStatusUntilSuccess = async (payload2, analysis_id) => {
        let success = false;
        // addMultipleApiRunning.current = true;
        // dispatch(setAddMultipleCardsApiRunning(true));

        while (!success) {
            let finalResponse = await checkAsyncStatus(payload2);

            if (finalResponse.bground_task_status === 'Completed' || finalResponse.bground_task_status === 'Failed') {
                success = true;  // Set success to true to stop the loop

                // dispatch(setAddAllClicked(false));
                // setAddAllQuestionsClicked(false);


                dispatch(setDisableReportIndex(-1));
                dispatch(
                    setNotificationData({
                        type: NotificationTypes.SUCCESS,
                        message: (
                            <>
                                <strong>Refresh Export Process Completed </strong>
                            </>
                        ),
                    })
                );


                //   setting all states empty
                //   dispatch(resetRefreshReport());
                dispatch(removeDisableReportId(analysis_id));





                // console.log("result setting empty 2");

                // setAddAllApiData({});
                // addAllApiDataRef.current={};
                // setIsApiResponseReceived(false);
                // addMultipleApiRunning.current = false;
                // dispatch(setAddMultipleCardsApiRunning(false));

            } else {
                // console.log("Not successful, retrying...");
                // Wait for 5 seconds before retrying
                await new Promise(resolve => setTimeout(resolve, 5000));
            }
        }
    };

    const refreshCreateNewExportFn = async () => {
        const payload = {
            user_id: userInfo.user_id,
            analysis_id: oldAnalysisId,
            screen_name: "analysis_library",
            analysis_refresh_type: "refresh_current",
            comparator_data:
                filterData.length > 0
                    ? filterData
                    : [
                        {
                            age: null,
                            race: null,
                            gender: null,
                            ethnicity: null,
                            geography: null,
                            indication: null,
                            comparator_nm: "",
                            origin_country: null,
                            sub_indication: null,
                            therapeutic_area: null,
                        },
                    ],
        };
    }

    // const getSecondModalContent = () => {
    //     switch (refreshModal1Action) {
    //         case 'refreshData':
    //             return <p>You selected <strong>Option 1</strong> in the first modal.</p>;
    //         case 'refreshUpdateCriteria':
    //             return <p>You selected <strong>Option 2</strong> in the first modal.</p>;
    //         default:
    //             return <p>No action recorded.</p>;
    //     }
    // };

    //   const handleNameChange=(e)=>{

    //   }


    return {
        openFirstModal,
        handleFirstModalClick,
        handleSecondModalClick,
        refreshExistingReportFn,
        checkStatusUntilSuccess,
        refreshCreateNewExportFn,
        isMaxAllowedCardsLimitReached
        // getSecondModalContent
    }


}